import connect from './connect';

export { InviteNewUser } from './InviteNewUser';

export default connect;
